import React from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  trayHeader: {
    maxHeight: '56px',
    minHeight: '56px',
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '8px',
  },
  headerTitle: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.palette.text.primary,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  closeButton: {
    padding: '4px',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },
});

const TrayHeader = ({ classes, title, onClose, showCloseButton = true, children }) => {
  return (
    <Grid container className={classes.trayHeader}>
      <Grid item xs>
        <span className={classes.headerTitle}>{title}</span>
      </Grid>

      <Grid item className={classes.headerActions}>
        {children}
        {showCloseButton && onClose && (
          <Tooltip title="Close">
            <IconButton className={classes.closeButton} size="small" onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
};

TrayHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  children: PropTypes.node,
};

export default withStyles(styles)(TrayHeader);
